export default function PHP_var_export() {
  return (
    <div>
      <h1>PHP_var_export</h1>
    </div>
  );
}
